// extracted by mini-css-extract-plugin
export var errorIcon = "_lq-1";
export var nameLogo = "_lq-0";